import React, { PureComponent } from "react";
import styled from 'styled-components';
import { Loader } from "react-loaders";

import { patchRequest } from '../../../api/ApiService';
import { isSurveyFinished, isSurveyStarted } from '../../../api/Surveys';

import TeamRolesSelector from './selector';

import CheckedIcon from '../../../containers/assets/icon-teams-roles-checked.svg';
import UncheckedIcon from '../../../containers/assets/icon-teams-roles-unchecked.svg';
import EditIcon from '../../../containers/assets/icon-teamplayers-edit.svg';

import SurveyPogressCompletedIcon from '../../../containers/assets/icon-team-survey-progress-completed.svg';
import SurveyPogressIncompleteIcon from '../../../containers/assets/icon-team-survey-progress-incomplete.svg';
import SurveyPogressInProgressIcon from '../../../containers/assets/icon-team-survey-progress-in-progress.svg';
import SurveyPogressNotStartedIcon from '../../../containers/assets/icon-team-survey-progress-not-started.svg';

import { teamPlayerRoles } from './../../constants';

const Table = styled.table`
  width: 100%;
  font-family: 'Mukta Vaani';
  font-size: 14px;
  border-top: 1px solid #DEE0E3;
`;

const TableHeadRow = styled.tr`
  background: #F5F6F7;
  box-shadow: inset 0px -1px 0px #DEE0E3;
`;

const TableHeadCell = styled.th`
  padding: 16px;
  line-height: 16px;
  font-weight: 700 !important;
  position: relative;
  
  &:after {
    display: block;
    content: '';
    width: 1px;
    height: 16px;
    background: #CED1D6;
    position: absolute;
    top: 50%;
    transform: translateY(-50%);
    right: 0;
  }

  &:last-child:after {
    display: none;
  }

  ${p => p.withSelector && `
    width: 155px;
  `}
  
  ${p => p.withActions && `
    width: 180px;
  `}
`;

const TableRow = styled.tr`
  box-shadow: inset 0px -1px 0px #ECEDEF;

  &:nth-child(2n-1) {
    background: #FAFBFD;
  }

  ${p => p.activeRow && `
    background: #EBF2FF !important;
  `}
`;

const TableCell = styled.td`
  padding: 12px 16px;

  ${p => p.withActions && `
    display: flex;
  `}
`;

const RoleBadge = styled.div`
  display: inline-block;
  padding: 2px 10px;
  border-radius: 16px;
  line-height: 20px;
  font-weight: 500;
  border: 1px solid;
  text-align: center;

  ${p => (p.role && p.role === 'CEO') && `{
    color: #ECA427;
    border-color: #ECA427;
    background: #FFF8EB;
  }`}}

  ${p => (p.role && p.role === 'PD') && `{
    color: #55B4BC;
    border-color: #55B4BC;
    background: #ECF6F7;
  `}}
  
  ${p => (p.role && p.role === 'PM') && `{
    color: #5C91F5;
    border-color: #5C91F5;
    background: #EBF2FF;
  `}}
  
  ${p => (p.role && p.role === 'OP') && `{
    color: #EC5E59;
    border-color: #EC5E59;
    background: #FAEDED;
  `}}
  
  ${p => (p.role && p.role === 'FI') && `{
    color: #9B77FF;
    border-color: #A98DF6;
    background: #F4F1FA;
  `}}
`;

const RegisteredIcond = styled.img`
  width: 15.75px;
  height: 15.75px;
`;

const TableButton = styled.button`
  border: 2px solid #D5D9DD;
  border-radius: 4px;
  line-height: 20px;
  font-weight: 500;
  color: rgba(0, 27, 59, 0.6);

  ${p => p.saveButton && `
    background: #5C91F5;
    border-color: #5C91F5;
    color: #fff;
    margin-left: 8px;
  `}
`;

const EditButtonIcon = styled.img`
  width: 12px;
  height: 12px;
  margin-right: 6px;
`;

const ButtonLoader = styled.div`
  width: 20px;
  height: 20px;
  display: flex;
  align-items: center;
  justify-content: center;

  > .loader {
    margin-top: 0 !important;
    margin-left: 0 !important;

    .loader-inner div {
      width: 15px;
      height: 15px;
      border-color: #fff !important;
    }
  }
`;

const SurveyStatusWrapper = styled.div`
  display: flex;
  align-items: center;
`;

const SurveyStatusIcon = styled.div`
  width: 18px;
  height: 18px;

  img {
    width: 100%;
    height: 100%;
  }
`;

const SurveyProgressTextsWrapper = styled.div`
  display: flex;
  flex-direction: column;
  margin-left: 8px;
`;

const SurveyProgressText = styled.div`
  font-weight: 500;
  font-size: 14px;
  line-height: 20px;
  color: #282A2E;

  
  ${p => (p.status && p.status === 'Not Started') && `{
    color: rgba(0, 27, 59, 0.38);
  `}}
`;

const SurveyProgressStatusText = styled.div`
  color: rgba(0, 27, 59, 0.6);
  font-size: 12px;
  line-height: 14px;

  ${p => (p.status && p.status === 'Closed') && `{
    color: rgba(0, 27, 59, 0.38);
  `}}
`;

class TeamsRolesTable extends PureComponent {
  constructor(props) {
    super(props);

    this.state = {
      activeEditedRow: 0,
      activeEditedTeamId: 0,
      activeEditedRole: null,
      editedRowChanged: false,
      saveButtonLoading: false
    };
  }

  handleTeamPlayerButtonClick = (teamPlayerId, teamId, role) => {
    this.setState({
      activeEditedRow: teamPlayerId,
      activeEditedTeamId: teamId,
      activeEditedRole: role
    });
  };

  handleTeamSelectChange = (value) => {
    this.setState({
      editedRowChanged: true,
      activeEditedTeamId: value
    })
  }

  handleRoleSelectChange = (value) => {
    this.setState({
      editedRowChanged: true,
      activeEditedRole: value
    })
  }

  handleSaveButtonClick = (teamPlayerId, teamId, role) => {
    this.setState({
      saveButtonLoading: true
    });

    patchRequest(
      `${process.env.REACT_APP_API_URL}v2/games/teamplayers/${teamPlayerId}/`
    )
      .send({
        team: teamId,
        role: role
      })
      .then(res => {
        const { teamPlayers, changeTeamPlayers } = this.props;

        const updatedTeamPlayers = teamPlayers.map(teamPlayer => teamPlayer.id === teamPlayerId ? { ...teamPlayer, team: teamId, role: role } : teamPlayer);
        changeTeamPlayers(updatedTeamPlayers);

        this.setState({
          saveButtonLoading: false,
          activeEditedRow: 0,
          activeEditedTeamId: 0,
          activeEditedRole: null
        });
      })
      .catch(err => {
        this.setState({
          saveButtonLoading: false
        });
      });
  }

  render() {
    const {
      teamPlayers,
      courseMembers,
      availableTeams,
      surveys,
      surveysFeedbacks
    } = this.props;

    const {
      activeEditedRow,
      activeEditedTeamId,
      activeEditedRole,
      editedRowChanged,
      saveButtonLoading
    } = this.state;

    const surveysStatuses = surveys.map(survey =>
      isSurveyFinished(survey)
        ? 'Closed'
        : isSurveyStarted(survey)
          ? 'Open'
          : ''
    );

    return (
      <Table>
        <thead>
          <TableHeadRow>
            <TableHeadCell>Name</TableHeadCell>
            <TableHeadCell>Email</TableHeadCell>
            <TableHeadCell withSelector>Team</TableHeadCell>
            <TableHeadCell withSelector>Role</TableHeadCell>
            <TableHeadCell>Registered</TableHeadCell>
            {
              surveys.map((survey, index) => (
                <TableHeadCell key={index}>{survey.name}</TableHeadCell>
              ))
            }
            <TableHeadCell withActions>Actions</TableHeadCell>
          </TableHeadRow>
        </thead>
        <tbody>
          {
            teamPlayers.map((teamPlayer, index) => {
              const currentTeam = availableTeams[' ' + Number(teamPlayer.team)];
              const teamName = currentTeam ? currentTeam : teamPlayer.team;

              const currentCourseMember = courseMembers.find(courseMember => courseMember.user === teamPlayer.user.username);
              const registered = currentCourseMember ? currentCourseMember.registered_at : null;
              const registeredIconSrc = registered ? CheckedIcon : UncheckedIcon;

              const activeRow = activeEditedRow === teamPlayer.id;

              let surveyProgressTexts = [];
              let surveyProgressIcons = [];
              surveys.forEach((survey, index) => {
                const teamPlayerFeedbacks = surveysFeedbacks[index].filter(surveysFeedback => surveysFeedback.giver === teamPlayer.user.id);

                surveyProgressTexts[index] = 'Not Started';
                surveyProgressIcons[index] = SurveyPogressNotStartedIcon;

                if (teamPlayerFeedbacks.length) {
                  if (teamPlayerFeedbacks.length === teamPlayerFeedbacks.filter(surveysFeedback => surveysFeedback.completed === true).length) {
                    surveyProgressTexts[index] = 'Completed';
                    surveyProgressIcons[index] = SurveyPogressCompletedIcon;
                  } else {
                    if (surveysStatuses[index] === 'Open') {
                      surveyProgressTexts[index] = 'In Progress';
                      surveyProgressIcons[index] = SurveyPogressInProgressIcon;
                    } else {
                      surveyProgressTexts[index] = 'Incomplete';
                      surveyProgressIcons[index] = SurveyPogressIncompleteIcon;
                    }
                  }
                }
              });

              return (
                <TableRow key={index} activeRow={activeRow}>
                  <TableCell>{`${teamPlayer.user.first_name} ${teamPlayer.user.last_name}`}</TableCell>
                  <TableCell>{teamPlayer.user.email}</TableCell>
                  <TableCell>
                    {
                      activeRow &&
                      <TeamRolesSelector
                        options={availableTeams}
                        selectedOptionId={activeEditedTeamId}
                        onSelectorChange={this.handleTeamSelectChange}
                      />
                    }
                    {
                      !activeRow &&
                      teamName
                    }
                  </TableCell>
                  <TableCell>
                    {
                      activeRow &&
                      <TeamRolesSelector
                        options={teamPlayerRoles}
                        selectedOptionId={activeEditedRole}
                        onSelectorChange={this.handleRoleSelectChange}
                      />
                    }
                    {
                      !activeRow &&
                      <RoleBadge role={teamPlayer.role}>{teamPlayerRoles[teamPlayer.role]}</RoleBadge>
                    }
                  </TableCell>
                  <TableCell>
                    <RegisteredIcond src={registeredIconSrc} />
                  </TableCell>
                  {
                    surveys.map((survey, index) => (
                      <TableCell key={index}>
                        <SurveyStatusWrapper>
                          <SurveyStatusIcon>
                            <img src={surveyProgressIcons[index]} alt="Survey Progress" />
                          </SurveyStatusIcon>
                          <SurveyProgressTextsWrapper>
                            <SurveyProgressText status={surveyProgressTexts[index]}>
                              {surveyProgressTexts[index]}
                            </SurveyProgressText>
                            <SurveyProgressStatusText status={surveysStatuses[index]}>
                              {surveysStatuses[index]}
                            </SurveyProgressStatusText>
                          </SurveyProgressTextsWrapper>
                        </SurveyStatusWrapper>
                      </TableCell>
                    ))
                  }
                  <TableCell withActions>
                    {
                      !activeRow &&
                      <TableButton onClick={() => this.handleTeamPlayerButtonClick(teamPlayer.id, teamPlayer.team, teamPlayer.role)}>
                        <EditButtonIcon src={EditIcon} />
                        <span>Edit</span>
                      </TableButton>
                    }
                    {
                      activeRow &&
                      <TableButton onClick={() => this.handleTeamPlayerButtonClick(0, 0, null)}>
                        <span>Cancel</span>
                      </TableButton>
                    }
                    {
                      (activeRow && editedRowChanged) &&
                      <TableButton saveButton onClick={() => this.handleSaveButtonClick(teamPlayer.id, activeEditedTeamId, activeEditedRole)}>
                        {
                          saveButtonLoading &&
                          <ButtonLoader>
                            <Loader type="ball-scale-ripple" active />
                          </ButtonLoader>
                        }
                        {
                          !saveButtonLoading &&
                          <span>Save</span>
                        }
                      </TableButton>
                    }
                  </TableCell>
                </TableRow>
              );
            })
          }
          {
            !teamPlayers.length &&
            <TableRow>
              <TableCell>Nothing found</TableCell>
            </TableRow>
          }
        </tbody>
      </Table>
    );
  }
}

export default TeamsRolesTable;



// WEBPACK FOOTER //
// ./src/instructor/components/teams-roles/table.js